import { computed } from "vue";
import { formatLocaleNumber } from "@/src/utils/analyticsChartUtils.js";

export const useRadialBarChartOptions = ({
  baseOptions,
  isDark,
  textColor,
  labels,
  series,
  formattedValues,
  getPieFormattedValue,
  decimalPlaces,
}) => {
  return computed(() => {
    const labelsArray = labels.value.length > 0 ? labels.value : ["Value"];
    
    const options = {
      ...baseOptions.value,
      labels: labelsArray,
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: { 
            size: "60%",
            margin: 5,
          },
          track: {
            background: isDark.value ? "#374151" : "#e5e7eb",
            strokeWidth: "100%",
            margin: 5,
          },
          dataLabels: {
            name: {
              fontSize: "14px",
              fontFamily: "Proxima Nova, sans-serif",
              color: textColor,
              offsetY: 20,
              show: true,
            },
            value: {
              fontSize: "24px",
              fontFamily: "Proxima Nova, sans-serif",
              fontWeight: 600,
              color: textColor,
              offsetY: -15,
              show: true,
              formatter: () => {
                const formatted = getPieFormattedValue(0);
                if (formatted) return formatted;
                const raw = series.value?.[0];
                if (raw !== undefined && raw !== null) {
                  return formatLocaleNumber(raw, { decimalPlaces: decimalPlaces?.value });
                }
                return "";
              },
            },
          },
        },
      },
      legend: {
        show: false,
      },
    };
    
    return options;
  });
};

// Helper to convert raw values to percentages based on max value
export const convertToGaugePercentages = (seriesArray) => {
  if (!seriesArray || seriesArray.length === 0) return seriesArray;
  if (seriesArray.length === 1) return seriesArray; // Single value, no conversion needed
  
  const maxValue = Math.max(...seriesArray, 1);
  return seriesArray.map(val => Math.round((val / maxValue) * 100));
};

